/* Çark (snippets/spin-wheel.liquid). Canlı temadaki (v24) çark mantığı korunur: gösterim sınırı, ödül/olasılık,
   form gönderimi ve depolama anahtarları değişmedi. Ek: "Aramıza katıl" — ilk ziyarette 15 sn sonra açılış
   (yalnız ana sayfa/koleksiyon/arama) + onay kutusu ortak optin metniyle; kayıt ayrıca Patirti.optin.send ile. */
(function () {
  'use strict';
  var STORAGE_WON = 'ty_spin_won_v1';
  var STORAGE_HISTORY = 'ty_spin_history_v2';
  var COOLDOWNS_MS = [3 * 3600e3, 24 * 3600e3, 7 * 24 * 3600e3];
  var MAX_SHOWS = 1;
  var KVKK_VERSION = 'kvkk_ticari_v1';
  var FIRST_VISIT_MS = 15000;
  var FIRST_VISIT_PAGES = { index: 1, collection: 1, search: 1 };
  var REDUCED_MOTION = false;
  try { REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (_) {}

  // Ödül tanımları canlıyla aynı (kod, etiket, dilim, ağırlık). Ekran metinleri tema dil dosyasından gelir.
  var PRIZES = [
    // 31 Eki 2026: kargo bedava kalktı (ücretsiz kargo ödülü ve SPINKARGO kodu kapatıldı); dilimler %5'e döndü.
    // 2. ürün %50: kodsuz; Shopify otomatik indirimi (1-11 Kasım) sepette kendiliğinden uygulanır. Kampanya bitince çarktan kalkar.
    { type: 'second50', code: '', label: '2. Ürün %50', slices: [1, 4], weight: 50 },
    { type: 'percent5', code: 'SPIN5', label: '%5 İndirim', slices: [0, 2, 5], weight: 40 },
    { type: 'percent10', code: 'SPIN10', label: '%10 İndirim', slices: [3], weight: 10 }
  ];
  var SECOND50_END = Date.parse('2026-11-11T20:59:59Z');
  var SECOND50_ON = Date.now() <= SECOND50_END;
  if (!SECOND50_ON) {
    PRIZES.shift();
    PRIZES[0].slices = [0, 1, 2, 4, 5]; PRIZES[0].weight = 90;
    PRIZES[1].weight = 10;
  }

  function getHistory() {
    try {
      var r = localStorage.getItem(STORAGE_HISTORY);
      if (!r) return { count: 0, lastShownAt: 0, dismissCount: 0 };
      var h = JSON.parse(r);
      return { count: h.count | 0, lastShownAt: h.lastShownAt | 0, dismissCount: h.dismissCount | 0 };
    } catch (_) { return { count: 0, lastShownAt: 0, dismissCount: 0 }; }
  }
  function saveHistory(h) { try { localStorage.setItem(STORAGE_HISTORY, JSON.stringify(h)); } catch (_) {} }
  function alreadyWon() { try { return !!localStorage.getItem(STORAGE_WON); } catch (_) { return false; } }
  function canShow() {
    if (alreadyWon()) return false;
    var h = getHistory();
    if (h.count >= MAX_SHOWS) return false;
    if (h.count === 0) return true;
    var cd = COOLDOWNS_MS[h.count - 1] || Infinity;
    return (Date.now() - h.lastShownAt) >= cd;
  }

  var el = document.querySelector('[data-spin-wheel]');
  if (!el || !canShow()) return;

  var config = {};
  try { config = JSON.parse(document.querySelector('[data-spin-config]').textContent) || {}; } catch (_) { config = {}; }
  var str = config.strings || {};
  var HEADLINES = config.headlines || [];
  var SHEETS_URL = config.endpoint || '';
  var CART_URL = config.cartUrl || '/cart';
  var $ = function (sel) { return el.querySelector(sel); };
  if (!SECOND50_ON) {
    // kampanya bitti: 2. ürün dilimleri %5'e döner
    Array.prototype.forEach.call(el.querySelectorAll('[data-slice-label]'), function (t) {
      t.textContent = str.sliceFallback || '%5'; t.setAttribute('class', 'sw__label--b');
    });
    Array.prototype.forEach.call(el.querySelectorAll('.sw__slice--promo'), function (p) { p.setAttribute('class', 'sw__slice sw__slice--b'); });
  }

  function pickPrize() {
    var t = 0, i;
    for (i = 0; i < PRIZES.length; i++) t += PRIZES[i].weight;
    var r = Math.random() * t, a = 0;
    for (i = 0; i < PRIZES.length; i++) { a += PRIZES[i].weight; if (r < a) return PRIZES[i]; }
    return PRIZES[0];
  }

  function applyHeadline(h) {
    if (!h) return;
    $('[data-spin-badge]').textContent = h.badge;
    $('[data-spin-title]').textContent = h.title;
    $('[data-spin-sub]').innerHTML = h.sub;
  }

  var priorOverflow = '';
  function isOpen() { return el.classList.contains('is-open'); }
  function open(reason) {
    if (!canShow() || isOpen()) return;
    var h = getHistory();
    // İlk-ziyaret açılışı "Aramıza katıl" metnini, çıkış niyeti mevcut "Gitme!" metnini gösterir.
    applyHeadline(reason === 'first_visit_15s' && config.firstVisit ? config.firstVisit : HEADLINES[Math.min(h.count, HEADLINES.length - 1)]);
    el.hidden = false;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    priorOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var close = el.querySelector('.sw__close');
    if (close) close.focus({ preventScroll: true });
    h.count += 1; h.lastShownAt = Date.now();
    saveHistory(h);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'spin_shown', spin_reason: reason, spin_count: h.count }); } catch (_) {}
  }
  function close() {
    if (!isOpen()) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    el.hidden = true;
    document.body.style.overflow = priorOverflow;
    if (!alreadyWon()) { var h = getHistory(); h.dismissCount += 1; saveHistory(h); }
  }

  el.querySelectorAll('[data-spin-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'), function (n) { return n.getClientRects().length && !n.closest('[hidden]'); });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !el.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  var lastTriggerAt = 0;
  var lastAtcAt = 0;

  // Satın alma niyeti koruması: sepet çekmecesi açıkken, sepet/checkout sayfasındayken
  // veya son 30 sn içinde sepete ürün eklendiyse çark ASLA araya girmez.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/cart/add') > -1) lastAtcAt = Date.now();
  }, true);
  document.addEventListener('cart:added', function () { lastAtcAt = Date.now(); });
  function cartDrawerOpen() { return !!document.querySelector('drawer-panel.cart-drawer[open]'); }
  // Başka bir pencere (menü, hızlı bakış, kupon vb.) ya da arama paneli açıkken üstüne açılmaz.
  function otherLayerOpen() {
    return !!document.querySelector('modal-dialog[open], drawer-panel[open]') || document.documentElement.classList.contains('sp-open');
  }
  function cartHasItems() {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) if (!nodes[i].hidden && parseInt(nodes[i].textContent, 10) > 0) return true;
    return false;
  }
  function purchaseIntent() {
    if (cartDrawerOpen()) return true;
    if (/^\/(cart|checkout)/.test(location.pathname)) return true;
    if (Date.now() - lastAtcAt < 30000) return true;
    return false;
  }
  function tryTrigger(reason) {
    if (!canShow()) return;
    if (purchaseIntent() || otherLayerOpen()) return;
    if (Date.now() - lastTriggerAt < 2000) return;
    lastTriggerAt = Date.now();
    open(reason);
  }

  // Tetikleyiciler — çıkış niyeti + ilk ziyarette 15 sn; satın almaya gideni durdurmayız.
  var armed = false;
  function arm() {
    if (armed) return; armed = true;
    // 1) Masaüstü: fare ekranın üstünden çıkıyor.
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && !e.toElement && e.clientY <= 0) tryTrigger('mouse_exit_top'); });
    // 2) Mobil: sayfa başında hızlı yukarı kaydırma — YALNIZCA sepet boşken (sepeti doluysa ödemeye gidiyordur).
    //    Geri tuşu (history.pushState/popstate) tetikleyicisi bilinçli olarak yok; geri eklemeyin.
    var lastY = window.scrollY, lastT = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now(), dy = lastY - y, dt = t - lastT;
      if (dy > 80 && dt < 250 && y < 200 && !cartHasItems()) tryTrigger('mobile_scroll_up');
      lastY = y; lastT = t;
    }, { passive: true });
  }
  // Kurulum gecikmesi ~3 sn (etkileşim yoksa +2 sn).
  var engaged = false;
  ['mousemove', 'scroll', 'click', 'touchstart', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, function once() { engaged = true; window.removeEventListener(ev, once); }, { passive: true, once: true });
  });
  setTimeout(function () { if (engaged) arm(); else setTimeout(arm, 2000); }, 3000);

  // 3) İlk ziyaret: sayfada 15 sn kalındıysa "Aramıza katıl" penceresi. Yalnız ana sayfa, koleksiyon, arama.
  //    Başka katman/sekme gizliyken kısa süre ertelenir (3 sn aralıkla en çok 20 deneme); sepette ürün varsa hiç açılmaz.
  //    Gösterim sınırı canShow() ile aynı: bir kez gösterildiyse/çevrildiyse tekrar açılmaz.
  function scheduleFirstVisit() {
    if (!FIRST_VISIT_PAGES[config.pageType]) return;
    var tries = 0;
    function attempt() {
      if (!canShow() || isOpen() || cartHasItems()) return;
      if (document.hidden || purchaseIntent() || otherLayerOpen()) {
        if (++tries <= 20) setTimeout(attempt, 3000);
        return;
      }
      tryTrigger('first_visit_15s');
    }
    setTimeout(attempt, FIRST_VISIT_MS);
  }
  scheduleFirstVisit();

  var form = $('[data-spin-form]');
  var phoneInp = $('[data-spin-phone]');
  var phoneWrap = $('[data-spin-phone-wrap]');
  var phoneErr = $('[data-spin-phone-err]');
  var kvkkInp = $('[data-spin-kvkk]');
  var kvkkLabel = $('[data-spin-kvkk-label]');
  var consentLabelEl = $('[data-spin-consent-label]');
  var consentLegalEl = $('[data-spin-consent-legal]');
  var kvkkErr = $('[data-spin-kvkk-err]');
  var goBtn = $('[data-spin-go]');
  var goLabel = $('[data-spin-go-label]');
  var wheel = $('[data-spin-disc]');
  var stageForm = $('[data-stage="form"]');
  var stageRes = $('[data-stage="result"]');
  var prizeTxt = $('[data-spin-prize-text]');
  var codeLoading = $('[data-spin-code-loading]');
  var codeVal = $('[data-spin-code]');
  var copyBtn = $('[data-spin-copy]');
  var cta = $('[data-spin-cta]');
  var legalRes = $('[data-spin-legal-result]');
  var spinResultCallback = null;

  // Tek yön, quintic ease-out (1-(1-t)^5): başta en hızlı, sonda tam durur; geri dönmez.
  function animateWheel(finalDeg) {
    // Hareket azaltma tercihinde kısa, tek hamlelik dönüş.
    var startTime = null, DURATION = REDUCED_MOTION ? 700 : 6000;
    function frame(ts) {
      if (!startTime) startTime = ts;
      var elapsed = Math.min(ts - startTime, DURATION);
      var e = 1 - Math.pow(1 - elapsed / DURATION, 5);
      wheel.style.transform = 'rotate(' + (finalDeg * e) + 'deg)';
      if (elapsed < DURATION) requestAnimationFrame(frame);
      else {
        wheel.style.transform = 'rotate(' + finalDeg + 'deg)';
        setTimeout(function () { if (spinResultCallback) { spinResultCallback(); spinResultCallback = null; } }, 300);
      }
    }
    requestAnimationFrame(frame);
  }

  // Ekranda görünen tam onay metni (etiket + yasal satır) — izinli numara kaydına kanıt olarak gider.
  function consentText() {
    var t = (consentLabelEl ? consentLabelEl.textContent : '') + ' ' + (consentLegalEl ? consentLegalEl.textContent : '');
    return t.replace(/\s+/g, ' ').trim();
  }

  // Onay kutusu (işaretsiz gelir): buton yalnızca onaydan sonra aktif.
  kvkkInp.addEventListener('change', function () {
    goBtn.disabled = !kvkkInp.checked;
    goLabel.textContent = kvkkInp.checked ? str.spin : str.locked;
    if (kvkkInp.checked) { kvkkLabel.classList.remove('is-error'); kvkkErr.hidden = true; }
  });

  // Telefon maskesi: 5XX XXX XX XX
  phoneInp.addEventListener('input', function () {
    var v = phoneInp.value.replace(/\D/g, '').slice(0, 10), out = '';
    if (v.length > 0) out = v.slice(0, 3);
    if (v.length >= 4) out += ' ' + v.slice(3, 6);
    if (v.length >= 7) out += ' ' + v.slice(6, 8);
    if (v.length >= 9) out += ' ' + v.slice(8, 10);
    phoneInp.value = out;
    phoneErr.hidden = true;
    phoneWrap.classList.remove('is-error');
    phoneInp.removeAttribute('aria-invalid');
  });

  function validate() {
    var ok = true;
    var digits = phoneInp.value.replace(/\D/g, '');
    if (digits.length !== 10 || !/^5/.test(digits)) {
      phoneErr.textContent = str.phoneError; phoneErr.hidden = false;
      phoneWrap.classList.add('is-error'); phoneInp.setAttribute('aria-invalid', 'true');
      ok = false;
    } else { phoneErr.hidden = true; phoneWrap.classList.remove('is-error'); phoneInp.removeAttribute('aria-invalid'); }
    if (!kvkkInp.checked) {
      kvkkErr.textContent = str.kvkkError; kvkkErr.hidden = false;
      kvkkLabel.classList.add('is-error');
      ok = false;
    } else { kvkkErr.hidden = true; kvkkLabel.classList.remove('is-error'); }
    return ok;
  }

  // Sabit kod — müşteri başına tek kullanım Shopify indirim ayarında kontrol edilir.
  function getStaticCode(prizeType) {
    if (prizeType === 'percent5') return Promise.resolve('SPIN5');
    if (prizeType === 'percent10') return Promise.resolve('SPIN10');
    return Promise.resolve('SPIN5');
  }

  function showCode(code) {
    codeLoading.hidden = true;
    codeVal.textContent = code; codeVal.hidden = false;
    copyBtn.hidden = false;
    cta.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CART_URL);
    cta.hidden = false;
    legalRes.hidden = false;
  }

  // Kodsuz ödül: indirim sepette otomatik uygulanır; kod kutusu yerine açıklama + alışverişe yönlendirme.
  function showNoCode() {
    var box = $('[data-spin-code-box]');
    if (box) box.hidden = true;
    legalRes.textContent = str.second50Note; legalRes.hidden = false;
    cta.textContent = str.second50Cta; cta.href = config.shopUrl || '/collections/all'; cta.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validate()) return;

    var prize = pickPrize();
    var sliceIdx = prize.slices[Math.floor(Math.random() * prize.slices.length)];
    var sliceCenter = sliceIdx * 60 + 30;
    // 8 tam tur saat yönünde + hedef dilimi göstergenin altına getir.
    var finalDeg = (REDUCED_MOTION ? 360 : 8 * 360) + (360 - sliceCenter) % 360;
    goBtn.disabled = true;
    goLabel.textContent = str.spinning;
    animateWheel(finalDeg);

    var phoneE164 = '+90' + phoneInp.value.replace(/\D/g, '');
    var consentAt = new Date().toISOString();

    // İzinli numara kaydı (ortak assets/optin.js): fire-and-forget, başarısız olsa da çark/ödül engellenmez.
    try {
      var optin = window.Patirti && window.Patirti.optin;
      if (optin && optin.send) optin.send({ phone: phoneE164, source: 'wheel', ticari: true, consentText: consentText() }).catch(function () {});
    } catch (_) {}

    // Sepet nitelikleri
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { '_spin_phone': phoneE164, '_spin_prize': prize.type, '_spin_kvkk_accepted_at': consentAt, '_spin_sms_consent_at': consentAt, '_spin_kvkk_version': KVKK_VERSION } }) }).catch(function () {});

    // Shopify müşteri kaydı (pazarlama izni)
    var synthEmail = 'spin-' + phoneE164.replace(/\D/g, '') + '@subscribers.patirti.com';
    var fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', synthEmail);
    fd.append('contact[first_name]', 'Spin Wheel'); fd.append('contact[phone]', phoneE164);
    fd.append('contact[accepts_marketing]', 'yes'); fd.append('contact[tags]', 'spin-wheel,' + prize.type);
    fetch('/contact#contact_form', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});

    // Yerel kayıt
    try { localStorage.setItem('ty_spin_contact', JSON.stringify({ phone: phoneE164, consent: true, ts: consentAt, prize: prize.type })); } catch (_) {}
    try { document.cookie = 'ty_spin_phone=' + encodeURIComponent(phoneE164) + ';path=/;max-age=2592000;samesite=lax'; } catch (_) {}

    // Google Sheets (Apps Script) loglama
    if (SHEETS_URL) {
      try { fetch(SHEETS_URL, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ timestamp: consentAt, phone: phoneE164, prize_code: prize.code, prize_label: prize.label, kvkk_accepted: true, sms_consent: true, kvkk_version: KVKK_VERSION, page_url: location.href, referrer: document.referrer || '', user_agent: navigator.userAgent }) }).catch(function () {}); } catch (_) {}
    }

    var codePromise = getStaticCode(prize.type);

    // Animasyon bitince sonuç ekranı
    spinResultCallback = function () {
      try { localStorage.setItem(STORAGE_WON, prize.type); } catch (_) {}
      prizeTxt.textContent = str[prize.type] || prize.label;
      stageForm.hidden = true;
      stageRes.hidden = false;
      if (prize.type === 'second50') showNoCode(); else codePromise.then(showCode);
    };

    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'spin_submitted', spin_prize: prize.type }); } catch (_) {}
  });

  copyBtn.addEventListener('click', function () {
    var code = codeVal.textContent.trim();
    var done = function () {
      copyBtn.textContent = str.copied; copyBtn.classList.add('is-copied');
      setTimeout(function () { copyBtn.textContent = str.copy; copyBtn.classList.remove('is-copied'); }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done);
    else {
      var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(ta); done();
    }
  });
})();
